import * as React from 'react';

import classnames from 'classnames';

import styles from './two-line-info.module.css';

type Props = {
    label: string | React.ReactNode;
    mainAction?: React.ReactNode;
    children: React.ReactNode;
    rightAligned?: boolean;
};

export function TwoLineInfo(props: Props) {
    return (
        <div className={props.rightAligned ? 'text-align-right' : undefined}>
            <div className={classnames('flex justify-sb align-start', styles.label)}>
                <span>{props.label}</span>
                {props.mainAction}
            </div>
            {props.children}
        </div>
    );
}
